import { useNavigate } from "react-router-dom";
import "./NotFound.css";
import NotFoundSvg from "../../assets/images/404NotFound.svg";
import { useEffect } from "react";

const NotFound = () => {
  const navigate = useNavigate();
  var token = localStorage.getItem("token");
  useEffect(()=>{
   token = localStorage.getItem("token");
    if(token){
      navigate(-1);
      return;
    }

  },[]);

  const goToBack = () => {
    const token = localStorage.getItem("token");
    if(token){
      navigate(-1);
    }else{
     navigate("/login");
     localStorage.clear();
      sessionStorage.clear();
    }
  };

  return (
    <>
        {!token &&
    <div className="pg-n-f">
      <div className="text-center">
        <div className="notFound">
          <img
            src={NotFoundSvg}
            alt="404"
            style={{ height: "250px", width: "330px" }}
          />
          <span className="textRed">Not Found</span>
        </div>

        <div className="mt-3">
          <span className="headingcolor d-block">
            What on Earth are you doing here!?
          </span>
          <span className="d-block mt-3 headingcolor">
            Well, this is awkward, the page you were trying to view does not exist
          </span>
        </div>

        <div className="mt-4">
          <button
            className="btn btn-primary"
            onClick={goToBack}
          >
            GO BACK
          </button>
        </div>
      </div>
    </div>
    }
    </>
  );
};

export default NotFound;
